import React from 'react';
import {
    editRequestBtnStyle,
    editRequestTitleContainerStyle,
    GoBackLinkComponent,
    leftHeaderContainerStyle
} from '@vivli/shared/components';
import { RequestTitleComponent } from './request-title.component';
import { AdminHeaderTitleView, AmrAdminHeaderTitleView, ButtonView } from '@vivli/shared/views';
import { useParams } from 'react-router';

interface LeftHeaderComponentProps {
    title?: string;
    onEditTitleClick?: () => void;
    showEditTitleButton: boolean;
    myDataRequests?: boolean;
    isAmr?: boolean;
}

export const LeftHeaderComponent = ({ title, onEditTitleClick, showEditTitleButton, myDataRequests, isAmr }: LeftHeaderComponentProps) => {
    const { status } = useParams();
    const appTypeDestination = myDataRequests && isAmr ? `/mydatarequests/` : `/admin/requests/`;
    const goBackDestination = `${appTypeDestination}${status || 'active' || 'draft'}`;
    return (
        <>
            {showEditTitleButton ? (
                <div style={leftHeaderContainerStyle}>
                    <GoBackLinkComponent destination={goBackDestination} />

                    <div style={editRequestTitleContainerStyle}>
                        {isAmr ? (
                            <AmrAdminHeaderTitleView title={title} style={{ padding: 0 }} />
                        ) : (
                            <AdminHeaderTitleView title={title} style={{ padding: 0 }} truncateText={true} />
                        )}

                        <ButtonView onClick={onEditTitleClick} style={editRequestBtnStyle}>
                            Edit Request Title
                        </ButtonView>
                    </div>
                </div>
            ) : (
                <div style={leftHeaderContainerStyle} className="do-not-print">
                    <GoBackLinkComponent destination={goBackDestination} />
                    <RequestTitleComponent myDataRequests={myDataRequests} title={title} />
                </div>
            )}
        </>
    );
};
